export default __webpack_public_path__ + "static/Think-of-everything-1e8f7588bf09ce0c07fc8db2ddcb8297.jpg";